export default __webpack_public_path__ + "static/media/black_right_arrow.525b36a7.svg";